import getEwsRequestDateString from 'owa-mail-store/lib/services/utils/getEwsRequestDateString';
import getServiceContextFolderId from 'owa-mail-store/lib/services/utils/getServiceContextFolderId';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import itemId from 'owa-service/lib/factory/itemId';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
function createConversationAction(conversationContext, isReadValue, targetFolderId) {
    return conversationAction({
        Action: 'SetReadState',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        IsRead: isReadValue,
        ConversationLastSyncTime: getEwsRequestDateString(conversationContext.conversationLastSyncTimeStamp),
        SuppressReadReceipts: true,
        ContextFolderId: targetFolderId,
    });
}
function configureRequestBody(conversationContexts, isReadValue, contextFolderId) {
    var targetFolderId = getServiceContextFolderId(contextFolderId);
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createConversationAction(conversationContext, isReadValue, targetFolderId);
    });
    return applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * Marks conversations as read/unread
 * @param conversationContexts Context about the conversations to be updated
 * @param isReadValue read/unread boolean state
 * @param contextFolderId the context for which the read/unread is being applied (only items of the conversation in this folder are changing read/unread state)
 * @param requestOptions request options to be passed in
 */
export default function markConversationsAsReadService(conversationContexts, isReadValue, contextFolderId, requestOptions) {
    var requestBody = configureRequestBody(conversationContexts, isReadValue, contextFolderId);
    return applyConversationActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }, requestOptions).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=markConversationsAsReadService.js.map